import { Component, OnInit } from '@angular/core';
import {HtmlAnchor} from '../admin/admin-links/html-anchor';
import {Router} from '@angular/router';
import {RestService} from '../shared/rest/rest.service';
import {AlertService} from '../shared/alert.service';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent implements OnInit {

  links: HtmlAnchor[] = []

  constructor(private router: Router,
              private restService: RestService,
              private alertService: AlertService) { }

  ngOnInit(): void {
    this.restService.getAllAnchors().subscribe(value => {
      this.links = value;
    }, error => this.alertService.error("Links.error"))
  }

  navigateExternal(link: HtmlAnchor) {
      window.open(link.url,'_blank');
  }
}
